import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import { NavLink, Redirect } from 'react-router-dom';
import { BaseComponent, ChiamaAPI, BottoneAPI, Trad, Tipo, InputCalcolatore, InputLimite, Contesto, CampoData, GraficoCiambella, BarraPercentuale } from '../components/';

interface IFideValutazioneState {
    Dato: DatiFide.CRisAPIDatoTipi_FideValutazione;
    DatoEconomico: Dati.CRisAPIDatoDatiEconomici;
}

export class FideValutazione extends BaseComponent<Glob.IRouteGlobaleProps, IFideValutazioneState> {

    private ID_FideValutazione: number = 0;
    private IndiciAnalisi: any[] = [];
    private TrafficLight: string = "";
    private Result: string = "";

    private TrafficLightIndiceSituazioneFinanziaria: string = "";
    private TrafficLightIndiceIndebitamento: string = "";
    private TrafficLightIndiceRatingEsterno: string = "";
    private TrafficLightIndiceSinteticoAllRisks: string = "";

    private ResultIndiceSituazioneFinanziaria: string = "";
    private ResultIndiceIndebitamento: string = "";
    private ResultIndiceRatingEsterno: string = "";
    private ResultIndiceSinteticoAllRisks: string = "";

    constructor(props: any) {
        super(props);
        let FideValutazione = new DatiFide.CRisAPIDatoTipi_FideValutazione();
        let DatoEconomico = new Dati.CRisAPIDatoDatiEconomici();
        FideValutazione.Dato.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento;
        this.state = { Dato: FideValutazione, DatoEconomico: DatoEconomico };
        this.ID_FideValutazione = (this.props.match.params as any).ID_FideValutazione;
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);

        var M = Glob.GetMenu();
        M.Main = "Affidamento";
        M.ID_MenuMain = 24;
        M.VariabiliMenu = { ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString() };
        this.props.SetMenu(M);
    }

    private OnRis(sender: ChiamaAPI, dati: DatiFide.CRisAPIDatoTipi_FideValutazione, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_FideValutazione > 0) {
                this.setState({ Dato: dati });


                let menu = 0;
                if (dati.Dato.ID_FideValutazione > 0) {
                    menu = 24;
                }
                var M = Glob.GetMenu();
                M.Main = "Affidamento";
                M.ID_MenuMain = menu;
                M.VariabiliMenu = { ["{ID_FideAffidamento}"]: dati.Dato.ID_FideAffidamento.toString() };
                this.props.SetMenu(M);
            }
            else {
                dati.Dato.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento;
                this.setState({ Dato: dati });
            }
        }
        return <div>
            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4" style={{ backgroundColor: "#ebedf2", borderRadius: "1rem" }}>
                    <label className="col-form-label"><h6>{Trad.Trad("Copertura patrimoniale")}</h6></label>
                    <InputCalcolatore
                        IdA="ImportoAffidamento"
                        NameA="Dato.ImportoAffidamento"
                        IndicatoreA="€"
                        LabelA={Trad.Trad("Importo affidamento")}
                        ValoreA={this.state.Dato.Dato.ImportoAffidamento}
                        IdB="PatrimonioNetto"
                        NameB="Dato.PatrimonioNetto"
                        IndicatoreB="€"
                        LabelB={Trad.Trad("Patrimonio netto")}
                        ValoreB={this.state.Dato.Dato.PatrimonioNetto}
                        LabelC={Trad.Trad("Valutazione")}
                        Id="CalcolatoPatrimoniale"
                        Name="Dato.CalcolatoPatrimoniale"
                        Operazione="/"
                        Buono={1}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={5}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={5}
                        OnChange={(e) => { this.OnChange(e); }}
                        CSS=""
                        Verso="<" />
                </div>
                <div className="col-lg-4" style={{ backgroundColor: "#f5f6f8", borderRadius: "1rem" }}><label className="col-form-label"><h6>{Trad.Trad("Redditivita")}</h6></label>
                    <InputCalcolatore
                        IdA="MargineOperativo"
                        NameA="Dato.MargineOperativo"
                        IdB="PatrimonioNetto"
                        NameB="Dato.PatrimonioNetto"
                        Id="CalcolatoRedditivita"
                        Name="Dato.CalcolatoRedditivita"
                        Operazione="/"
                        IndicatoreA="€"
                        IndicatoreB="€"
                        Buono={0.10}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={0.03}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        LabelA={Trad.Trad("Margine Operativo")}
                        LabelB={Trad.Trad("Patrimonio netto")}
                        LabelC={Trad.Trad("Valutazione")}
                        Scarso={0.03}
                        ValoreA={this.state.Dato.Dato.MargineOperativo}
                        ValoreB={this.state.Dato.Dato.PatrimonioNetto}
                        OnChange={(e) => { this.OnChange(e); }}
                        CSS=""
                        Verso=">" />
                </div>
                <div className="col-lg-4" style={{ backgroundColor: "#ebedf2", borderRadius: "1rem" }}>
                    <label className="col-form-label"><h6>{Trad.Trad("Situazione finanziaria")}</h6></label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <InputCalcolatore
                            IdA="AttivoCircolante"
                            NameA="Dato.AttivoCircolante"
                            IndicatoreA="€"
                            LabelA={Trad.Trad("Attivo circolante")}
                            ValoreA={this.state.Dato.Dato.AttivoCircolante}
                            IdB="DebitiBreve"
                            IndicatoreB="€"
                            NameB="Dato.DebitiBreve"
                            LabelB={Trad.Trad("Debiti a breve")}
                            ValoreB={this.state.Dato.Dato.DebitiBreve}
                            Id="CalcolatoSituazioneFinanziaria"
                            Name="Dato.CalcolatoSituazioneFinanziaria"
                            LabelC={Trad.Trad("Valutazione")}
                            Operazione="/"
                            Buono={1}
                            BuonoFrase={Trad.Trad("BUONA")}
                            Accettabile={0.85}
                            AccettabileFrase={Trad.Trad("ACCETTABILE")}
                            ScarsoFrase={Trad.Trad("SCARSA")}
                            Scarso={0.85}
                            OnChange={(e) => { this.OnChange(e); }}
                            CSS="" Verso=">" />
                    </div>
                </div>
            </div>

            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4" style={{ backgroundColor: "#f5f6f8", borderRadius: "1rem" }}>
                    <label className="col-form-label"><h6>{Trad.Trad("Equilibrio patrimoniale")}</h6></label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <InputCalcolatore
                            IdA="TotalePassivo"
                            NameA="Dato.TotalePassivo"
                            IndicatoreA="€"
                            LabelA={Trad.Trad("Totale passivo")}
                            ValoreA={this.state.Dato.Dato.TotalePassivo}
                            IdB="PatrimonioNetto"
                            IndicatoreB="€"
                            NameB="Dato.PatrimonioNetto"
                            LabelB={Trad.Trad("Patrimonio netto")}
                            ValoreB={this.state.Dato.Dato.PatrimonioNetto}
                            Id="CalcolatoEquilibrioPatrimoniale"
                            Name="Dato.CalcolatoEquilibrioPatrimoniale"
                            LabelC={Trad.Trad("Valutazione")}
                            Operazione="/"
                            Buono={2.5}
                            BuonoFrase={Trad.Trad("BUONA")}
                            Accettabile={7}
                            AccettabileFrase={Trad.Trad("ACCETTABILE")}
                            ScarsoFrase={Trad.Trad("SCARSA")}
                            Scarso={7}
                            OnChange={(e) => { this.OnChange(e); }}
                            CSS="" Verso="<" />
                    </div>
                </div>
                <div className="col-lg-4" style={{ backgroundColor: "#ebedf2", borderRadius: "1rem" }}>
                    <label className="col-form-label"><h6>{Trad.Trad("Operatività")}</h6></label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <InputCalcolatore
                            IdA="ValoreProduzione"
                            NameA="Dato.ValoreProduzione"
                            IndicatoreA="€"
                            LabelA={Trad.Trad("Valore Produzione")}
                            ValoreA={this.state.Dato.Dato.ValoreProduzione}
                            IdB="AttivoCircolante"
                            IndicatoreB="€"
                            NameB="Dato.AttivoCircolante"
                            LabelB={Trad.Trad("Attivo circolante")}
                            ValoreB={this.state.Dato.Dato.AttivoCircolante}
                            Id="CalcolatoOperativita"
                            Name="Dato.CalcolatoOperativita"
                            LabelC={Trad.Trad("Valutazione")}
                            Operazione="/"
                            Buono={1.5}
                            BuonoFrase={Trad.Trad("BUONA")}
                            Accettabile={0.5}
                            AccettabileFrase={Trad.Trad("ACCETTABILE")}
                            ScarsoFrase={Trad.Trad("SCARSA")}
                            Scarso={0.5}
                            OnChange={(e) => { this.OnChange(e); }}
                            CSS="" Verso=">" />
                    </div>
                </div>
                <div className="col-lg-4" style={{ backgroundColor: "#f5f6f8", borderRadius: "1rem" }}>
                    <label className="col-form-label"><h6>{Trad.Trad("Andamento dell'attività di produzione")}</h6></label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <InputCalcolatore
                            IdA="ValoreProduzione"
                            NameA="Dato.ValoreProduzione"
                            IndicatoreA="€"
                            LabelA={Trad.Trad("Ultimo anno")}
                            ValoreA={this.state.Dato.Dato.ValoreProduzione}
                            IdB="AttivoCircolante"
                            IndicatoreB="€"
                            NameB="Dato.ValoreProduzionePrecedente"
                            LabelB={Trad.Trad("Anno precedente")}
                            ValoreB={this.state.Dato.Dato.ValoreProduzionePrecedente}
                            Id="CalcolatoAndamento"
                            Name="Dato.CalcolatoAndamento"
                            LabelC={Trad.Trad("Valutazione")}
                            Operazione="/"
                            Buono={1.1}
                            BuonoFrase={Trad.Trad("BUONA")}
                            Accettabile={0.75}
                            AccettabileFrase={Trad.Trad("ACCETTABILE")}
                            ScarsoFrase={Trad.Trad("SCARSA")}
                            Scarso={0.75}
                            OnChange={(e) => { this.OnChange(e); }}
                            CSS="" Verso=">" />
                    </div>
                </div>
            </div>
        </div>;
    }

    private valore(limiteA: number, limiteB: number, valore: number, verso: string, valoreAnnullante?: number, valoreDefault?: number): number {

        //console.warn("ControlloValore", limiteA, limiteB, "Valore:", valore, verso);
        if (valoreAnnullante != undefined && valoreDefault != undefined && valoreAnnullante == valore) {
            return valoreDefault;
        } else {
            if (verso == ">") {
                if (valore >= limiteA)
                    return 5;
                else if (valore >= limiteB && valore < limiteA)
                    return 3;
                else return 1;
            } else {
                if (valore <= limiteA)
                    return 5;
                else if (valore > limiteA && valore <= limiteB)
                    return 3;
                else return 1;
            }
        }
    }

    private OnRisDatoEconomico(sender: ChiamaAPI, dati: Dati.CRisAPIDatoDatiEconomici, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                this.setState({ DatoEconomico: dati });
            }
        }

        let AnniCostituzione = 0;
        if (this.state.DatoEconomico.Dato.DataCostituzione != null && this.state.DatoEconomico.Dato.DataCostituzione != undefined && this.state.DatoEconomico.Dato.DataCostituzione.getFullYear() > 1901) {
            AnniCostituzione = (new Date(Date.now())).getFullYear() - this.state.DatoEconomico.Dato.DataCostituzione.getFullYear();
        }
        let IndicePregiudizievoli = 0;
        if (this.state.DatoEconomico.Dato.Pregiudizievoli != null && this.state.DatoEconomico.Dato.Pregiudizievoli != undefined) {
            //Le pregiudizievoli hanno solo 2 valori
            this.state.DatoEconomico.Dato.Pregiudizievoli = this.state.DatoEconomico.Dato.Pregiudizievoli.trim();
            if (this.state.DatoEconomico.Dato.Pregiudizievoli.length == 2) {
                this.state.DatoEconomico.Dato.Pregiudizievoli += "V";
            }
            switch (this.state.DatoEconomico.Dato.Pregiudizievoli) {
                case "VVV":
                case "VGV":
                case "GVV":
                case "VVG":
                    IndicePregiudizievoli = 3;
                    break;
                case "VRV":
                case "VGG":
                case "VRG":
                case "VVR":
                case "VGR":
                case "GGV":
                case "GRV":
                case "GVG":
                case "GGG":
                case "GRG":
                case "GVR":
                case "GGR":
                    IndicePregiudizievoli = 2;
                    break;
                case "VRR":
                case "GRR":
                case "RVV":
                case "RGV":
                case "RRV":
                case "RVG":
                case "RGG":
                case "RRG":
                case "RVR":
                case "RGR":
                case "RRR":
                    IndicePregiudizievoli = 1;
                    break;
            }
        }
        let IndiceProtesti = 0;
        if (this.state.DatoEconomico.Dato.Protesti != null && this.state.DatoEconomico.Dato.Protesti != undefined) {
            if (this.state.DatoEconomico.Dato.Protesti.indexOf("R") >= 0) {
                IndiceProtesti = 1;
            }
            else if (this.state.DatoEconomico.Dato.Protesti.indexOf("G") >= 0) {
                IndiceProtesti = 2;
            }
            else {
                IndiceProtesti = 3;
            }
        }
        let IndiceProcedureConcorsuali = 0;
        if (this.state.DatoEconomico.Dato.ProcedureConcorsuali != null && this.state.DatoEconomico.Dato.ProcedureConcorsuali != undefined) {
            if (this.state.DatoEconomico.Dato.ProcedureConcorsuali.indexOf("R") >= 0) {
                IndiceProcedureConcorsuali = 1;
            }
            else if (this.state.DatoEconomico.Dato.ProcedureConcorsuali.indexOf("G") >= 0) {
                IndiceProcedureConcorsuali = 2;
            }
            else {
                IndiceProcedureConcorsuali = 3;
            }
        }

        let indiceTotale: number = 0;



        //Limit of Exposure VS Net Capital
        indiceTotale += this.valore(1, 5, this.state.Dato.Dato.ImportoAffidamento / this.state.Dato.Dato.PatrimonioNetto, "<");
        //console.warn("1", indiceTotale);

        //Profitability
        indiceTotale += this.valore(0.10, 0.03, this.state.Dato.Dato.MargineOperativo / this.state.Dato.Dato.PatrimonioNetto, ">");
        //console.warn("2", indiceTotale);

        //Financial Situation
        indiceTotale += this.valore(1, 0.85, this.state.Dato.Dato.AttivoCircolante / this.state.Dato.Dato.DebitiBreve, ">");
        //console.warn("3", indiceTotale);

        //Liabilities VS Net Capital
        indiceTotale += this.valore(2.5, 7, this.state.Dato.Dato.TotalePassivo / this.state.Dato.Dato.PatrimonioNetto, "<");
        //console.warn("4", indiceTotale);

        //Turnover vs Curret Assets
        indiceTotale += this.valore(1.5, 0.5, this.state.Dato.Dato.ValoreProduzione / this.state.Dato.Dato.AttivoCircolante, ">");
        //console.warn("5", indiceTotale);

        //Production Trend
        indiceTotale += this.valore(1.1, 0.75, this.state.Dato.Dato.ValoreProduzione / this.state.Dato.Dato.ValoreProduzionePrecedente, ">");
        //console.warn("6", indiceTotale);

        //Prejudicials
        indiceTotale += this.valore(3, 2, IndicePregiudizievoli, ">");
        //console.warn("7", indiceTotale);

        //Years of Establishment
        indiceTotale += this.valore(5, 3, AnniCostituzione, ">");
        //console.warn("8", indiceTotale);

        //Score (indice sintetico Ribes)
        indiceTotale += this.valore(3, 6, this.state.DatoEconomico.Dato.Punteggio, "<");
        //console.warn("9", indiceTotale);

        //Asset Turnover
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeAssetTurnover, ">", 0, 4);
        //console.warn("10", indiceTotale);

        //Interest Coverage (Copertura Interessi)
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeCoperturaInteressi, ">", 0, 4);
        //console.warn("11", indiceTotale);

        //Current Ratio
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeCurrentRatio, ">", 0, 4);
        //console.warn("12", indiceTotale);

        //Average Duration of Liabilities (Durata Media dei Debiti)
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeDurataMediaDeiDebiti, ">", 0, 4);
        //console.warn("13", indiceTotale);

        //Self-Coverage of Fixed Assets (Autocopertura Immobilizzazioni)
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni, ">", 0, 4);
        //console.warn("14", indiceTotale);

        //Leverage
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeLeverage, ">", 0, 4);
        //console.warn("15", indiceTotale);

        //Financials Costs Turnover (Oneri fin./Val. Produzione)
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeOneriFinanziariValoreProduzione, ">", 0, 4);
        //console.warn("16", indiceTotale);

        //Quick Ratio
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeQuickRatio, ">", 0, 4);
        //console.warn("17", indiceTotale);

        //ROE
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeROE, ">", 0, 4);
        //console.warn("18", indiceTotale);

        //ROI
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeROI, ">", 0, 4);
        //console.warn("19", indiceTotale);

        //ROS
        indiceTotale += this.valore(8, 4, this.state.DatoEconomico.Dato.IndiceSettorialeROS, ">", 0, 4);
        //console.warn("20", indiceTotale);

        indiceTotale += this.valore(30, 16, this.state.DatoEconomico.Dato.NumeroDipendenti, ">");
        //console.warn("21", indiceTotale);


        //SEZIONE BLOCCO
        if (IndiceProtesti <= 1 || IndiceProcedureConcorsuali <= 1 || this.state.DatoEconomico.Dato.Punteggio == 0)
            indiceTotale = 0;

        let SituazioneFinanziaria: number = (this.state.DatoEconomico.Dato.DebitiOltreBTVersoBanche + this.state.DatoEconomico.Dato.DebitiCorrentiVersoBanche - this.state.DatoEconomico.Dato.AttivitaFinanziarie - this.state.DatoEconomico.Dato.Liquidita) / this.state.DatoEconomico.Dato.MargineOperativoLordo;

        if ((this.state.DatoEconomico.Dato.DebitiOltreBTVersoBanche + this.state.DatoEconomico.Dato.DebitiCorrentiVersoBanche - this.state.DatoEconomico.Dato.AttivitaFinanziarie - this.state.DatoEconomico.Dato.Liquidita) < 0 && this.state.DatoEconomico.Dato.MargineOperativoLordo >= 0) {
            SituazioneFinanziaria = 0;
        } else if (this.state.DatoEconomico.Dato.MargineOperativoLordo < 0) {
            SituazioneFinanziaria = 10;
        }
        let DebitoSuPatrimonioNetto: number = (this.state.DatoEconomico.Dato.PassivoConsolidato + this.state.DatoEconomico.Dato.PassivoCorrente) / this.state.DatoEconomico.Dato.PatrimonioNetto;

        if (SituazioneFinanziaria <= 3.5) {
            this.TrafficLightIndiceSituazioneFinanziaria = "/images/TrafficGreenLightTiny.png";
            this.ResultIndiceSituazioneFinanziaria = Trad.Trad("GO");
        } else if (SituazioneFinanziaria > 3.5 && SituazioneFinanziaria <= 5) {
            this.TrafficLightIndiceSituazioneFinanziaria = "/images/TrafficYellowLightTiny.png";
            this.ResultIndiceSituazioneFinanziaria = Trad.Trad("GO");
        } else {
            this.TrafficLightIndiceSituazioneFinanziaria = "/images/TrafficRedLightTiny.png";
            this.ResultIndiceSituazioneFinanziaria = Trad.Trad("REFERRAL");
        }

        if (DebitoSuPatrimonioNetto <= 2) {
            this.TrafficLightIndiceIndebitamento = "/images/TrafficGreenLightTiny.png";
            this.ResultIndiceIndebitamento = Trad.Trad("GO");
        } else if (DebitoSuPatrimonioNetto > 2 && DebitoSuPatrimonioNetto <= 3) {
            this.TrafficLightIndiceIndebitamento = "/images/TrafficYellowLightTiny.png";
            this.ResultIndiceIndebitamento = Trad.Trad("GO");
        } else {
            this.TrafficLightIndiceIndebitamento = "/images/TrafficRedLightTiny.png";
            this.ResultIndiceIndebitamento = Trad.Trad("REFERRAL");
        }

        if (this.state.DatoEconomico.Dato.Punteggio <= 3) {
            this.TrafficLightIndiceRatingEsterno = "/images/TrafficGreenLightTiny.png";
            this.ResultIndiceRatingEsterno = Trad.Trad("GO");
        } else if (this.state.DatoEconomico.Dato.Punteggio > 3 && this.state.DatoEconomico.Dato.Punteggio <= 5) {
            this.TrafficLightIndiceRatingEsterno = "/images/TrafficYellowLightTiny.png";
            this.ResultIndiceRatingEsterno = Trad.Trad("GO");
        } else {
            this.TrafficLightIndiceRatingEsterno = "/images/TrafficRedLightTiny.png";
            this.ResultIndiceRatingEsterno = Trad.Trad("REFERRAL");
        }

        if (indiceTotale >= 70) {
            this.TrafficLightIndiceSinteticoAllRisks = "/images/TrafficGreenLightTiny.png";
            this.ResultIndiceSinteticoAllRisks = Trad.Trad("GO");
        } else if (indiceTotale >= 50 && indiceTotale < 70) {
            this.TrafficLightIndiceSinteticoAllRisks = "/images/TrafficYellowLightTiny.png";
            this.ResultIndiceSinteticoAllRisks = Trad.Trad("GO");
        } else {
            this.TrafficLightIndiceSinteticoAllRisks = "/images/TrafficRedLightTiny.png";
            this.ResultIndiceSinteticoAllRisks = Trad.Trad("REFERRAL");
        }

        if (SituazioneFinanziaria <= 5
            && DebitoSuPatrimonioNetto <= 3
            && this.state.DatoEconomico.Dato.Punteggio <= 5
            && (indiceTotale / 105 * 100) >= 50) {
            this.TrafficLight = "TrafficLightGreen";
            this.Result = Trad.Trad("GO");
        } else {
            this.TrafficLight = "TrafficLightYellow";
            this.Result = Trad.Trad("REFERRAL");
        }

        //console.warn("CONTROLLO", SituazioneFinanziaria, DebitoSuPatrimonioNetto, this.state.DatoEconomico.Dato.Punteggio, indiceTotale);

        this.IndiciAnalisi = [];

        this.IndiciAnalisi.push(<BarraPercentuale key="Index_1" Valore={indiceTotale} ValoreMassimo={105} Etichetta={Trad.Trad("IndiceAllRisks")} />);
        this.IndiciAnalisi.push(<div key="Index_2" className="m--space-10"></div>);

        /*
        if (SituazioneFinanziaria > 10) {
            this.IndiciAnalisi.push(<div key="Index_3">{Trad.Trad("IndiceSituazioneFinanziariaNonDisponibile")}</div>);
        } else {
            this.IndiciAnalisi.push(<BarraPercentuale key="Index_3" Valore={10 - SituazioneFinanziaria} ValoreMassimo={10} Etichetta={Trad.Trad("IndiceSituazioneFinanziaria")} pctYellow={0.65} />);
        }
        */

        this.IndiciAnalisi.push(<BarraPercentuale key="Index_3" Valore={10 - (SituazioneFinanziaria <= 10 ? SituazioneFinanziaria : 10)} ValoreMassimo={10} Etichetta={Trad.Trad("IndiceSituazioneFinanziaria")} pctYellow={0.8} />);
        this.IndiciAnalisi.push(<div key="Index_4" className="m--space-10"></div>);

        /*
        if (DebitoSuPatrimonioNetto > 10) {
            this.IndiciAnalisi.push(<div key="Index_5">{Trad.Trad("IndiceIndebitamentoNonDisponibile")}</div>);
        } else {
            this.IndiciAnalisi.push(<BarraPercentuale key="Index_5" Valore={10 - DebitoSuPatrimonioNetto} ValoreMassimo={10} Etichetta={Trad.Trad("IndiceIndebitamento")} pctYellow={0.8} />);
        }
        */

        this.IndiciAnalisi.push(<BarraPercentuale key="Index_5" Valore={10 - (DebitoSuPatrimonioNetto <= 10 ? DebitoSuPatrimonioNetto : 10)} ValoreMassimo={10} Etichetta={Trad.Trad("IndiceIndebitamento")} pctYellow={0.9} />);
        this.IndiciAnalisi.push(<div key="Index_6" className="m--space-10"></div>);

        /*
        if (this.state.DatoEconomico.Dato.Punteggio == 99) {
            this.IndiciAnalisi.push(<div key="Index_7">{Trad.Trad("IndiceRatingEsternoNonDisponibile")}</div>);
        } else {
            this.IndiciAnalisi.push(<BarraPercentuale key="Index_7" Valore={8 - (this.state.DatoEconomico.Dato.Punteggio <= 8 ? this.state.DatoEconomico.Dato.Punteggio : 8)} ValoreMassimo={8} Etichetta={Trad.Trad("IndiceRatingEsterno")} pctYellow={0.5} />);
        }
        */

        this.IndiciAnalisi.push(<BarraPercentuale key="Index_7" Valore={8 - (this.state.DatoEconomico.Dato.Punteggio <= 8 ? this.state.DatoEconomico.Dato.Punteggio : 8)} ValoreMassimo={8} Etichetta={Trad.Trad("IndiceRatingEsterno")} pctYellow={0.5} />);
        
        //this.PolareIndiciSintatici = <Bar data={IndiciSintetici} />;

        //this.BarraEsito = <BarraPercentuale Valore={indiceTotale} ValoreMassimo={105} />;

        //if (indiceTotale == 0) {
        //    this.BarraEsito = <div>{Trad.Trad("IndiceTotaleNonDisponibile")}</div>;
        //}



        return <div>
            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-3">
                    <label className="col-form-label"><h6>{Trad.Trad("Protesti")}</h6></label>
                    <InputLimite
                        Valore={IndiceProtesti}
                        Id="IndiceProtesti"
                        Name="IndiceProtesti"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={3}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={2}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                    />
                </div>
                <div className="col-lg-3">
                    <label className="col-form-label"><h6>{Trad.Trad("Pregiudizievoli")}</h6></label>
                    <InputLimite
                        Valore={IndicePregiudizievoli}
                        Id="IndicePregiudizievoli"
                        Name="IndicePregiudizievoli"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={3}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={2}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                    />
                </div>
                <div className="col-lg-3">
                    <label className="col-form-label"><h6>{Trad.Trad("ProcedureConcorsuali")}</h6></label>
                    <InputLimite
                        Valore={IndiceProcedureConcorsuali}
                        Id="DatoEconomico.Dato.IndiceProcedureConcorsuali"
                        Name="DatoEconomico.Dato.IndiceProcedureConcorsuali"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={3}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={2}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                    />
                </div>
                <div className="col-lg-3">
                    <label className="col-form-label"><h6>{Trad.Trad("AnniCostituzione")}</h6></label>
                    <InputLimite
                        Valore={AnniCostituzione}
                        Id="DatoEconomico.Dato.AnniCostituzione"
                        Name="DatoEconomico.Dato.AnniCostituzione"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={5}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={3}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                    />
                </div>
                <div className="col-lg-4">
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("Punteggio")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.Punteggio}
                        Id="DatoEconomico.Dato.Punteggio"
                        Name="DatoEconomico.Dato.Punteggio"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={3}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={6}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={8}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso="<"
                    />
                </div>
                <div className="col-lg-4">
                </div>
            </div>
            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeAssetTurnover")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeAssetTurnover}
                        Id="DatoEconomico.Dato.IndiceSettorialeAssetTurnover"
                        Name="DatoEconomico.Dato.IndiceSettorialeAssetTurnover"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeCoperturaInteressi")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeCoperturaInteressi}
                        Id="DatoEconomico.Dato.IndiceSettorialeCoperturaInteressi"
                        Name="DatoEconomico.Dato.IndiceSettorialeCoperturaInteressi"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeCurrentRatio")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeCurrentRatio}
                        Id="DatoEconomico.Dato.IndiceSettorialeCurrentRatio"
                        Name="DatoEconomico.Dato.IndiceSettorialeCurrentRatio"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
            </div>

            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeDurataMediaDeiDebiti")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeDurataMediaDeiDebiti}
                        Id="DatoEconomico.Dato.IndiceSettorialeDurataMediaDeiDebiti"
                        Name="DatoEconomico.Dato.IndiceSettorialeDurataMediaDeiDebiti"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni}
                        Id="DatoEconomico.Dato.IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni"
                        Name="DatoEconomico.Dato.IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeLeverage")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeLeverage}
                        Id="DatoEconomico.Dato.IndiceSettorialeLeverage"
                        Name="DatoEconomico.Dato.IndiceSettorialeLeverage"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
            </div>

            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeOneriFinanziariValoreProduzione")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeOneriFinanziariValoreProduzione}
                        Id="DatoEconomico.Dato.IndiceSettorialeOneriFinanziariValoreProduzione"
                        Name="DatoEconomico.Dato.IndiceSettorialeOneriFinanziariValoreProduzione"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeQuickRatio")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeQuickRatio}
                        Id="DatoEconomico.Dato.IndiceSettorialeQuickRatio"
                        Name="DatoEconomico.Dato.IndiceSettorialeQuickRatio"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeROE")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeROE}
                        Id="DatoEconomico.Dato.IndiceSettorialeROE"
                        Name="DatoEconomico.Dato.IndiceSettorialeROE"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
            </div>

            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeROI")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeROI}
                        Id="DatoEconomico.Dato.IndiceSettorialeROI"
                        Name="DatoEconomico.Dato.IndiceSettorialeROI"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("IndiceSettorialeROS")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.IndiceSettorialeROS}
                        Id="DatoEconomico.Dato.IndiceSettorialeROS"
                        Name="DatoEconomico.Dato.IndiceSettorialeROS"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={8}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={4}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                        ValoreNeutro={0}
                        NDFrase="ND"
                    />
                </div>
                <div className="col-lg-4">
                    <label className="col-form-label"><h6>{Trad.Trad("NumeroDipendenti")}</h6></label>
                    <InputLimite
                        Valore={this.state.DatoEconomico.Dato.NumeroDipendenti}
                        Id="DatoEconomico.Dato.NumeroDipendenti"
                        Name="DatoEconomico.Dato.NumeroDipendenti"
                        OnChange={this.OnChange}
                        Scrittura={false}
                        Buono={30}
                        BuonoFrase={Trad.Trad("BUONA")}
                        Accettabile={16}
                        AccettabileFrase={Trad.Trad("ACCETTABILE")}
                        ScarsoFrase={Trad.Trad("SCARSA")}
                        Scarso={0}
                        AbilitaDecremento={false}
                        AbilitaIncremento={false}
                        AbilitamentoBackGroundColor
                        Verso=">"
                    />
                </div>
            </div>
            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-12">
                    <label className="">{Trad.Trad("Commenti")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <textarea className="form-control" id="kt_autosize_1" rows={3} name="Dato.Note" value={this.state.Dato.Dato.Note || ""} onChange={this.OnChange}></textarea>
                    </div>
                </div>
            </div>
            <div className="form-group m-form__group row">
                <div className={Glob.DimensioneCSS(8)}>
                    {this.IndiciAnalisi}
                </div>
                <div className={Glob.DimensioneCSS(4) + " circleContenitor"}>
                    <div className={"circle " + this.TrafficLight}>
                        <div>
                            <h3>{this.Result}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }


    private BackGroundSinteticIndexColor(toGreen: number, toYellow: number, value: number): string {
        if (value <= toGreen)
            return "rgb(52, 191, 163)";
        else if (value > toGreen && value <= toYellow)
            return "rgb(255, 184, 34)";
        else
            return "rgb(244, 81, 108)";
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            if (this.ID_FideValutazione == 0) {
                this.props.history.replace("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FideValutazione/" + dati.ID_Chiave);
                Glob.InfoModaleSuccess(Trad.Trad("VALUTAZIONE"), Trad.TradParam("Valutazione salvata correttamente con ID: {1-S}", [dati.ID_Chiave]));
            }
        }
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPITipi<DatiFide.CDatiFideValutazione>();
        Ingr.Dato = this.state.Dato.Dato;
        //Ingr.Tipi = this.state.Dato.Tipi;
        return Ingr;
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.Log(Glob.LogCat.Form, false, "OnErroreBottoneAPI", errore, sender);
        Glob.InfoModaleError(Trad.Trad("ERRORE"), errore.message);
    }

    public render() {
        if (!this.ControlloAutorizzazione("FideValutazioneController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        var caricaDocumenti = <div></div>;
        if (this.ID_FideValutazione > 0) {
            caricaDocumenti = <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                <a href={"/file/" + this.state.Dato.Dato.ID_FideValutazione} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Documenti")}>
                    <i className="fa fa-archive"></i></a>
            </div>;
        }
        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Affidamento"), "/api/FideAffidamento/Contesto?ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento, "/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento));
        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={this.OnChange} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-tachometer-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">{Trad.Trad("Valutazione")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            {caricaDocumenti}
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <NavLink to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FideValutazione/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-6">
                                <label>ID</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.Dato.Dato.ID_FideAffidamento} name="Dato.ID_FideAffidamento" onChange={(e) => { this.OnChange(e) }} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <label>{Trad.Trad("Affidamento")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <Tipo URL={"/api/FideAffidamento/ListaAffidamentiAnagrafica?sottoscritti=false&ID_AnagA=" + (this.props.match.params as any).ID_Anag} Campo="Dato.ID_FideAffidamento" ID_Chiave={this.state.Dato.Dato.ID_FideAffidamento} ID_ChiaveString={this.state.Dato.Dato.ID_FideAffidamento.toString() || ""} OnAggiorna={this.OnChange} Disabilitato TradValori />
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-6">
                                <label className="">{Trad.Trad("Data valutazione")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData ValoreInArrivo={this.state.Dato.Dato.Data != undefined}
                                            Name="Dato.Data"
                                            Id="Dato.Data"
                                            Valore={this.state.Dato.Dato.Data}
                                            OnChange={this.OnChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <label>{Trad.Trad("TipoValutazioneEsito")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <Tipo Campo="Dato.ID_TipoValutazioneEsito" ID_ChiaveString={this.state.Dato.Dato.ID_TipoValutazioneEsito || Glob.Tipi_VA_InValutazione} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi["TipiFideValutazioneEsito"]} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <ChiamaAPI Aggiornare={1} URL={"/api/fidevalutazione/seleziona?ID_FideValutazione=" + this.ID_FideValutazione + "&ID_Anag=" + (this.props.match.params as any).ID_Anag + "&ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                        </div>
                        {this.state.Dato.Dato.ID_DatoEconomico > 0 &&
                            <ChiamaAPI Aggiornare={this.state.Dato.Dato.ID_DatoEconomico} URL={"/api/DatiEconomici/seleziona?ID_DatoEconomico=" + this.state.Dato.Dato.ID_DatoEconomico} OnRis={(s, d, dn) => this.OnRisDatoEconomico(s, d, dn)} OnErrore={this.OnErrore} />
                        }
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <BottoneAPI Default Testo={Trad.Trad("Salva")} URL="/api/fidevalutazione/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} Attivo={this.state.Dato.Dato.Note != undefined && this.state.Dato.Dato.Note.length > 15} />
                                    <button className={"btn btn-secondary " + this._VisibileScrittura} onClick={history.back} style={{ marginLeft: 5 }}>{Trad.Trad("Annulla")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/FideValutazione.tsx